export const UserRole = Object.freeze({
  ELEVATE: 'Elevate',
  IGNITE: 'Ignite',
});

export const startingSemester = { year: 2023, semester: 'autumn' };

export const MONTH_SECTION_HEIGHT = '348px';
export const MONTH_SECTION_BOX_WIDTH = '320px';
